// extracted by mini-css-extract-plugin
export default {"promoContainer":"PromoReleases__promoContainer--bGdiG"};